/* Farmacias LF · Header (sections/lf-header.liquid)
   1. Header pegajoso: se oculta al bajar y vuelve al subir (en celular, sin los chips de servicio).
   2. Mega menú de escritorio (botón «Categorías», paso del mouse por la barra y por la columna izquierda).
   3. Búsqueda a pantalla completa en el celular y texto de ayuda según el ancho.
   4. Barra de categorías que no cabe: oculta (y saca del foco) los enlaces que se pasan a una segunda línea.
   5. Editor de temas: abre el mega menú o el menú lateral al seleccionar un bloque.
   El menú lateral (#lf-menu-drawer) lo abre/cierra assets/lf-capsula.js (data-lf-open / data-lf-close). */
(() => {
  const mqMobile = window.matchMedia('(max-width: 749px)');
  const mqDesktop = window.matchMedia('(min-width: 990px)');
  const instances = new Map();

  const init = (root) => {
    const sectionId = root.dataset.sectionId;
    if (instances.has(sectionId)) instances.get(sectionId).abort();
    const ctrl = new AbortController();
    const signal = ctrl.signal;
    instances.set(sectionId, ctrl);

    const section = root.closest('.shopify-section') || root;
    const main = root.querySelector('[data-lf-main]');
    const row = root.querySelector('[data-lf-row]');
    const svc = root.querySelector('[data-lf-svc]');
    const search = root.querySelector('[data-lf-search]');
    const input = search && search.querySelector('input[type="search"]');
    const back = root.querySelector('[data-lf-search-back]');
    const mega = root.querySelector('[data-lf-mega]');
    const toggle = root.querySelector('[data-lf-mega-toggle]');
    const scrim = root.querySelector('[data-lf-mega-scrim]');
    const navLinks = root.querySelector('[data-lf-navlinks]');
    const drawer = document.getElementById('lf-menu-drawer');

    let height = 0;
    let lastY = window.scrollY;
    let ticking = false;
    let megaOpen = false;
    let megaByHover = false;
    let openTimer = null;
    let closeTimer = null;
    let itemTimer = null;

    /* ---------- 1. Medidas y header pegajoso ---------- */
    const measure = () => {
      height = root.offsetHeight;
      let stick = 0;
      if (mqDesktop.matches && svc) {
        stick = svc.offsetHeight;
      } else if (mqMobile.matches && root.dataset.lfStick !== 'completo' && search) {
        stick = Math.max(0, search.getBoundingClientRect().top - root.getBoundingClientRect().top);
      }
      section.style.setProperty('--lf-hd-h', `${height}px`);
      section.style.setProperty('--lf-hd-stick', `${-Math.round(stick)}px`);
      if (row && search && mqDesktop.matches) {
        const left = search.getBoundingClientRect().left - row.getBoundingClientRect().left;
        root.style.setProperty('--lf-ps-left', `${Math.round(left)}px`);
      }
      fitNav();
      setMegaTop();
    };

    const blocked = () =>
      megaOpen ||
      root.classList.contains('lf-is-searching') ||
      document.body.classList.contains('lf-no-scroll') ||
      document.body.classList.contains('overflow-hidden') ||
      (search && search.contains(document.activeElement) && !mqMobile.matches);

    const onScroll = () => {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      setMegaTop();
      if (blocked()) {
        lastY = y;
        return;
      }
      if (y <= 4) {
        section.classList.remove('lf-hd-hidden');
      } else if (y > lastY + 2 && y > height) {
        section.classList.add('lf-hd-hidden');
      } else if (y < lastY - 6) {
        section.classList.remove('lf-hd-hidden');
      }
      section.classList.toggle('lf-hd-compact', y > height);
      lastY = y;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(onScroll);
        }
      },
      { passive: true, signal }
    );
    window.addEventListener('resize', measure, { passive: true, signal });
    // Si el foco entra al header (teclado) mientras está oculto, vuelve a mostrarse
    root.addEventListener('focusin', () => section.classList.remove('lf-hd-hidden'), { signal });
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => measure());
      ro.observe(root);
      signal.addEventListener('abort', () => ro.disconnect());
    }

    /* ---------- 4. Barra de categorías: lo que no cabe queda fuera del foco ---------- */
    function fitNav() {
      if (!navLinks) return;
      const links = navLinks.querySelectorAll('a');
      if (!mqDesktop.matches) return;
      const top = links.length ? links[0].offsetTop : 0;
      links.forEach((a) => {
        const out = a.offsetTop > top + 2;
        a.style.visibility = out ? 'hidden' : '';
        if (out) a.setAttribute('tabindex', '-1');
        else a.removeAttribute('tabindex');
      });
    }

    /* ---------- 2. Mega menú ---------- */
    // Borde inferior del header: desde ahí parte el velo del mega menú y del buscador
    function setMegaTop() {
      if (!main) return;
      root.style.setProperty('--lf-mega-top', `${Math.round(main.getBoundingClientRect().bottom)}px`);
    }

    const activate = (panelId) => {
      if (!mega) return;
      const panel = panelId && mega.querySelector(`#${CSS.escape(panelId)}`);
      if (!panel) return;
      mega.querySelectorAll('[data-lf-mm-panel]').forEach((p) => {
        p.hidden = p !== panel;
      });
      mega.querySelectorAll('[data-lf-mm-item]').forEach((i) => {
        i.classList.toggle('lf-on', i.dataset.lfMmItem === panelId);
      });
      if (navLinks) {
        navLinks.querySelectorAll('[data-lf-mm-target]').forEach((a) => {
          a.classList.toggle('lf-on', megaOpen && a.dataset.lfMmTarget === panelId);
        });
      }
    };

    const openMega = (panelId, byHover = false) => {
      if (!mega || !mqDesktop.matches) return;
      clearTimeout(closeTimer);
      setMegaTop();
      megaOpen = true;
      megaByHover = byHover;
      mega.hidden = false;
      if (scrim) scrim.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      section.classList.remove('lf-hd-hidden');
      activate(panelId || (mega.querySelector('.lf-mm-item.lf-on') || mega.querySelector('[data-lf-mm-item]'))?.dataset.lfMmItem);
    };

    const closeMega = (focusToggle = false) => {
      if (!mega || !megaOpen) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      megaOpen = false;
      megaByHover = false;
      mega.hidden = true;
      if (scrim) scrim.hidden = true;
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (focusToggle) toggle.focus();
      }
      if (navLinks) navLinks.querySelectorAll('.lf-on').forEach((a) => a.classList.remove('lf-on'));
    };

    if (mega && toggle) {
      toggle.addEventListener(
        'click',
        () => {
          if (megaOpen && !megaByHover) closeMega();
          else openMega(null, false);
        },
        { signal }
      );

      if (navLinks) {
        navLinks.querySelectorAll('[data-lf-mm-target]').forEach((a) => {
          a.addEventListener(
            'mouseenter',
            () => {
              clearTimeout(openTimer);
              clearTimeout(closeTimer);
              const wait = megaOpen ? 60 : 180;
              openTimer = setTimeout(() => openMega(a.dataset.lfMmTarget, !megaOpen || megaByHover), wait);
            },
            { signal }
          );
          a.addEventListener('mouseleave', () => clearTimeout(openTimer), { signal });
        });
      }

      // Al salir del header con el mouse se cierra solo si se abrió pasando el mouse
      main.addEventListener(
        'mouseleave',
        () => {
          clearTimeout(openTimer);
          if (megaOpen && megaByHover) closeTimer = setTimeout(() => closeMega(), 280);
        },
        { signal }
      );
      main.addEventListener('mouseenter', () => clearTimeout(closeTimer), { signal });

      mega.querySelectorAll('[data-lf-mm-item]').forEach((item) => {
        item.addEventListener(
          'mouseenter',
          () => {
            clearTimeout(itemTimer);
            itemTimer = setTimeout(() => activate(item.dataset.lfMmItem), 90);
          },
          { signal }
        );
        item.addEventListener('mouseleave', () => clearTimeout(itemTimer), { signal });
        item.addEventListener('focus', () => activate(item.dataset.lfMmItem), { signal });
      });

      if (scrim) scrim.addEventListener('click', () => closeMega(), { signal });
      document.addEventListener(
        'click',
        (e) => {
          if (megaOpen && !main.contains(e.target)) closeMega();
        },
        { signal }
      );

      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Escape' && megaOpen) closeMega(true);
        },
        { signal }
      );

      // Con teclado: si el foco sale del header, se cierra
      main.addEventListener(
        'focusout',
        () => {
          setTimeout(() => {
            if (megaOpen && !main.contains(document.activeElement) && !megaByHover) closeMega();
          });
        },
        { signal }
      );

      mqDesktop.addEventListener('change', () => closeMega(), { signal });
    }

    /* ---------- 3. Búsqueda ---------- */
    const setPlaceholder = () => {
      if (!input) return;
      const ph = mqMobile.matches ? input.dataset.phM : input.dataset.phD;
      if (ph) input.placeholder = ph;
    };
    setPlaceholder();
    mqMobile.addEventListener('change', setPlaceholder, { signal });

    const enterSearch = () => {
      if (!mqMobile.matches || root.classList.contains('lf-is-searching')) return;
      root.classList.add('lf-is-searching');
      document.body.classList.add('lf-no-scroll');
    };
    const exitSearch = () => {
      if (!root.classList.contains('lf-is-searching')) return;
      root.classList.remove('lf-is-searching');
      if (!document.querySelector('.lf-panel.lf-is-open')) document.body.classList.remove('lf-no-scroll');
    };

    if (search) {
      search.addEventListener(
        'focusin',
        () => {
          enterSearch();
          if (megaOpen) closeMega();
        },
        { signal }
      );
      search.addEventListener(
        'focusout',
        () => {
          setTimeout(() => {
            if (!search.contains(document.activeElement)) exitSearch();
          });
        },
        { signal }
      );
      // Mantiene el foco dentro del buscador al tocar las búsquedas sugeridas (Safari no enfoca enlaces)
      search.querySelectorAll('.lf-ps-sugg, .lf-ps-help').forEach((el) => {
        el.addEventListener('mousedown', (e) => {
          if (e.target.closest('a')) e.preventDefault();
        }, { signal });
      });
    }
    if (back) {
      back.addEventListener(
        'click',
        () => {
          exitSearch();
          if (document.activeElement && search.contains(document.activeElement)) document.activeElement.blur();
        },
        { signal }
      );
    }
    mqMobile.addEventListener('change', (e) => { if (!e.matches) exitSearch(); }, { signal });

    /* ---------- 5. Editor de temas ---------- */
    const onBlockSelect = (e) => {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      const id = e.detail.blockId;
      if (mqDesktop.matches) {
        openMega(`LfMm-${id}`, false);
      } else if (drawer && window.LF) {
        const det = document.getElementById(`LfDr-${id}`);
        if (det) det.open = true;
        if (drawer.hidden) window.LF.openPanel(drawer);
      }
    };
    const onBlockDeselect = (e) => {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      closeMega();
    };
    document.addEventListener('shopify:block:select', onBlockSelect, { signal });
    document.addEventListener('shopify:block:deselect', onBlockDeselect, { signal });

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('load', measure, { once: true, signal });
  };

  // El menú lateral vive dentro de la sección (contenedor pegajoso con su propio z-index): se lleva al body
  // para que quede sobre el velo de lf-capsula.js igual que los demás paneles.
  const moveDrawer = (scope) => {
    const fresh = scope.querySelector('.shopify-section #lf-menu-drawer, [data-lf-header] ~ #lf-menu-drawer');
    if (!fresh) return;
    document.querySelectorAll('body > #lf-menu-drawer').forEach((d) => {
      if (d !== fresh) d.remove();
    });
    if (fresh.parentElement !== document.body) document.body.appendChild(fresh);
  };

  const boot = (scope = document) => {
    moveDrawer(scope);
    scope.querySelectorAll('[data-lf-header]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target.querySelector('[data-lf-header]')) return;
    boot(e.target);
    // El carro del header se volvió a dibujar: que vuelva a abrir el cajón
    const drawerCart = document.querySelector('cart-drawer');
    if (drawerCart && typeof drawerCart.setHeaderCartIconAccessibility === 'function') {
      drawerCart.setHeaderCartIconAccessibility();
    }
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('[data-lf-header]');
    if (!root) return;
    document.querySelectorAll('body > #lf-menu-drawer').forEach((d) => d.remove());
    const ctrl = instances.get(root.dataset.sectionId);
    if (ctrl) ctrl.abort();
    instances.delete(root.dataset.sectionId);
  });
})();
